import {
  FILTER_ENABLED_SLUGS,
  PAID_FILTER_ENABLED_SLUG_OVERRIDES,
  PAID_FILTER_ENABLED_SLUG_PREFIXES,
} from './store/constants';

const isFilterEnabledSlug = (slug: string, isGeoTargeted?: boolean): boolean =>
  FILTER_ENABLED_SLUGS.includes(slug) || !!isGeoTargeted;

const getPaidFilterSlugForPage = (slug: string, isGeoTargeted: boolean): string | undefined => {
  const paidSlugOverride = PAID_FILTER_ENABLED_SLUG_OVERRIDES[slug];
  if (paidSlugOverride) return paidSlugOverride;

  const paidPrefixFilterSlug = PAID_FILTER_ENABLED_SLUG_PREFIXES.find(({ prefix }) =>
    slug.startsWith(prefix),
  )?.filterSlug;

  if (paidPrefixFilterSlug) return paidPrefixFilterSlug;

  return isGeoTargeted ? slug : undefined;
};

export const getFilterSlugForPage = (
  slug: string,
  isPaid = false,
  isGeoTargeted = false,
): string | undefined => {
  if (isPaid) return getPaidFilterSlugForPage(slug, isGeoTargeted);

  return isFilterEnabledSlug(slug, isGeoTargeted) ? slug : undefined;
};
